import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import routes from "../routes";

import { getAll, setSort, setPage } from "../applications/actions";
import BlockLoader from "../components/BlockLoader";
import { SiteTemplate } from "../components/Site";
import { Table } from "../components/Table";
import { replacePlaceholders } from "../lib/utils";

import { format } from "date-fns";

class List extends Component {
  componentDidMount() {
    const { getAll } = this.props;
    getAll();
  }

  redirectToSingle = uid => {
    const { history } = this.props;
    history.push(replacePlaceholders(routes.applicationsSingle, { uid }));
  };

  render() {
    const { applications, setSort, setPage, params, result } = this.props;
    let i = 0;

    const ids = result && result.get("ids");

    return (
      <SiteTemplate title="Aplikacje">
        <BlockLoader
          isLoading={!ids}
          isEmpty={ids && ids.length === 0}
          noRowsText="Brak aplikacji"
        >
          <Table
            setSort={setSort}
            setPage={setPage}
            params={params}
            meta={result && result.get("meta")}
            labels={[
              {
                title: "Lp."
              },
              {
                sortField: "firstName",
                sortType: "alpha",
                title: "Imię"
              },
              {
                sortField: "lastName",
                sortType: "alpha",
                title: "Nazwisko"
              },
              {
                sortField: "email",
                sortType: "alpha",
                title: "Email"
              },
              {
                sortField: "phoneNumber",
                sortType: "numeric",
                title: "Telefon"
              },
              {
                sortField: "created_at",
                title: "Utworzono"
              },
              {
                title: ""
              }
            ]}
          >
            {ids &&
              ids.map(uid => {
                i += 1;
                const item = applications.get(uid);
                return (
                  <StyledTr
                    key={item.get("uid")}
                    onClick={() => this.redirectToSingle(uid)}
                  >
                    <td>
                      {(params.get("currentPage") - 1) * params.get("limit") +
                        i}
                    </td>
                    <td>{item.get("firstName")}</td>
                    <td>{item.get("lastName")}</td>
                    <td>{item.get("email")}</td>
                    <td>{item.get("phoneNumber")}</td>
                    <td>
                      {format(item.get("createdAt"), "HH:mm DD.MM.YYYYr.")}
                    </td>
                    <StyledTd />
                  </StyledTr>
                );
              })}
          </Table>
        </BlockLoader>
      </SiteTemplate>
    );
  }
}

const StyledTr = styled.tr`cursor: pointer;`;
const StyledTd = styled.td`padding: 0 !important;`;

List = connect(
  state => ({
    applications: state.entities.get("applications"),
    params: state.applications.params.get("default"),
    result: state.applications.results.get("default")
  }),
  { getAll, setSort, setPage }
)(List);
List = withRouter(List);
export default List;



// WEBPACK FOOTER //
// ./src/applications/List.js